/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useParams } from 'react-router-dom';
import { type FC, type PropsWithChildren } from 'react';

import { useHasSider } from '@coze-foundation/global-adapter';
import { useCreateBotAction } from '@coze-foundation/global';
import { RequireAuthContainer } from '@coze-foundation/account-ui-adapter';
import { useRouteConfig } from '@coze-arch/bot-hooks';

import { AbrWorkspaceSubMenu } from './abr-workspace-sub-menu';
import { AbrTopBar } from './abr-top-bar';

import '../theme/abr-tokens.less';
import styles from './abr-shell.module.less';

export const AbrGlobalLayoutComposed: FC<PropsWithChildren> = ({
  children,
}) => {
  const config = useRouteConfig();
  const hasSider = useHasSider();
  const { space_id } = useParams();

  const { createBotModal } = useCreateBotAction({
    currentSpaceId: space_id,
    skipGuideModal: true,
  });

  return (
    <RequireAuthContainer
      needLogin={!!config.requireAuth}
      loginOptional={!!config.requireAuthOptional}
    >
      <div className={styles.shell}>
        {hasSider ? <AbrTopBar /> : null}
        <div className={styles.body}>
          {hasSider ? <AbrWorkspaceSubMenu /> : null}
          <main className={styles.main}>{children}</main>
        </div>
        {createBotModal}
      </div>
    </RequireAuthContainer>
  );
};
